import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const ServiceRequestRowSkeleton = () => (
  <div className="service-request-row" aria-hidden>
    <div className="service-request-row-checkbox">
      <Skeleton variant="rect" width="1.1rem" height="1.1rem" />
    </div>
    <div className="service-request-row-identity">
      <div className="service-request-row-number">
        <Skeleton variant="text" width="9rem" />
      </div>
      <div className="service-request-row-subject">
        <Skeleton variant="text" width="14rem" />
      </div>
      <div className="service-request-row-visibility">
        <Skeleton variant="rect" width="8rem" height="1.4rem" />
      </div>
    </div>
    <div className="service-request-row-status">
      <Skeleton
        variant="rect"
        width="6rem"
        height="1.4rem"
        className="service-request-skeleton-branded"
      />
    </div>
    <div className="service-request-row-property">
      <Skeleton
        variant="text"
        width="6rem"
        className="service-request-skeleton-branded"
      />
    </div>
  </div>
);

export default ServiceRequestRowSkeleton;